import preparedReducer from './reducer';
import { requestTsBySite } from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'tsBySite';

export const selectors = state => state[SLICE_NAME];

export const actions = {
  requestTsBySite,
};
